/** Localize breadcrumbs immutably while preserving their English labels. DOC*/
export const localizeNavigationPath = (navigationPath, locale) => {
    const updatedPath = navigationPath.map(item => {
        const englishValue = item.englishValue || item.translations?.ENG ||
            (locale === "ENG" ? item.path : item.englishValue);
        const path = locale === "FRA"
            ? item.translations?.FRA || englishValue || item.path
            : englishValue || item.path;

        return path === item.path && englishValue === item.englishValue
            ? item
            : { ...item, path, englishValue };
    });

    return updatedPath.every((item, index) => item === navigationPath[index])
        ? navigationPath
        : updatedPath;
};
